export default {   
    all: function() {
        return window.axios.get(`users`);
    },
    
    search: function (params) {
        return window.axios.get(`users`, {params:params});
    },

    authorise: function (id) {
        return window.axios.get(`users/authorise/${id}`);
    },

    get: function (id) {
        return window.axios.get(`users/${id}`);
    },
    
    update: function (id, data) {
        return window.axios.put(`users/${id}`, data);
    },

    changePassword: function (data) {
        return window.axios.post('users/change-password', data);
    },
}